
    import { bootstrapPopover } from '@/directives/bootstrap-popover';
    import { ValidationProvider } from "vee-validate";
    //import DatePicker from 'v-calendar/lib/components/date-picker.umd';
    import moment from 'moment';
    import VCalendar from 'v-calendar';
    import Vue from 'vue';

    export default Vue.extend({
        name: 'DatePickerSimple',
        model: {
            prop: 'selectedDate'
        },
        components: {
            ValidationProvider,
            'v-date-picker': VCalendar.DatePicker 
        },
        directives: {
            bootstrapPopover
        },
        props: {
            value: {
                type: String,
                default: ""
            },
            tag: {
                type: String,
                default: 'li'
            },
            placeholder: {
                type: String,
                default: "",
                required: false
            },            
            rules: {
                type: [String, Object],
                default: ""
            },
            label: {
                type: String,
                default: ""
            },
            name: {
                type: String,
                default: ""
            },
            helpText: {
                type: String,
                default: ""
            },
            popoverText: {
                type: String,
                default: ""
            },
            vid: {
                type: String,
                default: undefined
            },
            showRequiredLabel: {
                type: Boolean,
                required: false,
                default: true
            },
            formGroupClasses: {
                type: Array,
                default: () => [],
            },
            inputClasses: {
                type: Array,
                default: () => [],
            },
            pastDatesOnly: {
                type: Boolean,
                default: false
            },
            futureDatesOnly: {
                type: Boolean,
                default: false
            },
            dateFormat: {
                type: String,
                default: ""
            },
            outputDateFormat: {
                type: String,
                default: "YYYY-MM-DD"
            },
            showDropDownArrow: {
                type: Boolean,
                default: true
            },
            noInitialValue: {
                type: Boolean,
                default: false
            }
        },
        data() { 
            return {
                isOpen: false,
                dateFormatDisplayStringLong: 'dddd DD MMMM, YYYY',
                currentValueDate: null as null|Date,
                attrs: [
                    {
                        // highlight style
                        highlight: {
                            color: 'purple',
                            fillMode: 'light',
                        }
                    },
                    {
                        // a dot for the current day
                        dot: {
                            backgroundColor: '#4e9a3c',
                        },
                        dates: [
                            moment().toDate()
                        ],
                    }
                ]
            }
        },
        watch: {
            value: {
                handler(val) {
                    if (!val) {
                        this.currentValueDate = null;
                    }
                    else {
                        this.currentValueDate = moment(val).toDate();
                    }
                },
                immediate: true             
            },
            currentValueDate(val) {
                if (!val)
                    this.$emit("input", "");
                else
                    this.$emit("input", moment(val, this.outputDateFormat).format(this.outputDateFormat));
            }
        },
        computed: {
            displayDateFormat(): string {
                if (this.dateFormat)
                    return this.dateFormat;
                else return this.dateFormatDisplayStringLong; 
            },
            title(): string|null { 
                if (this.currentValueDate == null) {
                    return null;
                }
                else {
                    return moment(this.currentValueDate).format(this.displayDateFormat);
                }               
            }
        },
        methods: {
            toggleDropDown() {
                this.isOpen = !this.isOpen;
            },
            openDropDown() {
                this.isOpen = true;
            },
            closeDropDown(event) {
                if(!event.currentTarget.contains(event.relatedTarget)) { 
                    this.isOpen = false;
                }
            }
        },
        mounted() {
            if (this.noInitialValue) {
                this.currentValueDate = null;
                this.attrs[1].dates = [];
            }
        }
    });
